import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { IStoreState } from "../../../../../reducers/types";
import { FlightBookPassengerSelection } from "./component";
import {
  getPackageAvailabilityAdultsCount,
  getPackageAvailabilityChildren,
} from "../../../../availability/reducer";
import {
  getFareTripDetailsById,
  getSelectedTrip,
} from "../../../../flight-shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = getSelectedTrip(state);
  return {
    searchedAdultsCount: getPackageAvailabilityAdultsCount(state),
    searchedChildrenCount: getPackageAvailabilityChildren(state).length,
    tripDetails: selectedTrip?.tripId
      ? getFareTripDetailsById(state)[selectedTrip.tripId]
      : undefined,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightBookPassengerSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFlightBookPassengerSelection = withRouter(
  connector(FlightBookPassengerSelection)
);
